import React, { useState, useEffect } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper, CircularProgress } from '@mui/material';
import { MdOutlineCheckCircle, MdOutlineCancel } from 'react-icons/md';
import bg_boat_atmost from '../../../images/banner-home-atmost.png';
import './style.css';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { getBookingByUUID } from '../../../service/booking_service';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const { t } = useTranslation('success');
  const language = Cookies.get('language');
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState(false);
  const [bookingID, setBookingID] = useState(''); // Use state for booking ID

  useEffect(() => {
    i18next.changeLanguage(language);
    if (id) {
      setBookingID(id); // Update booking ID state
      handleGetBookingById(id);
    } else {
      navigate('/404');
    }
  }, [language]); // Removed id from dependency array

  const handleGetBookingById = async (id) => {
    setIsLoading(true);
    try {
      const res = await getBookingByUUID({ id, token: Cookies.get('token') });

      if (res?.data?.status === 'รอให้บริการ') {
        setStatus(true);
      } else {
        setStatus(false);
      }
    } catch (error) {
      console.error("Error fetching booking:", error);
      navigate('/');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        backgroundImage: `url(${bg_boat_atmost})`,
        backgroundSize: '100% auto',
        backgroundPosition: 'bottom',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
        </Box>
      ) : (
        <Container maxWidth="sm">
          <Paper
            elevation={3}
            sx={{
              p: 4,
              mt: 4,
              textAlign: 'center',
              boxShadow: '3px 3px 15px #ddd',
              marginTop: '15%',
            }}
          >
            {status ? (
              <>
                <MdOutlineCheckCircle style={{ fontSize: 100, color: '#4caf50', marginBottom: '16px' }} />
                <Typography variant="h4" gutterBottom>
                  {t('title_complate')}
                </Typography>
                <Typography variant="body1" paragraph>
                  {t('subtitle_complate')}
                </Typography>
                <Box sx={{ mt: 3 }}>
                  <Button variant="outlined" color="primary" onClick={() => navigate('/')}>
                    {t('btn')}
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <MdOutlineCancel style={{ fontSize: 100, color: 'red', marginBottom: '16px' }} />
                <Typography variant="h4" gutterBottom>
                  {t('title_error')}
                </Typography>
                <Typography variant="body1" paragraph>
                  {t('subtitle_error')}
                </Typography>
                <Box sx={{ mt: 3 }}>
                  <Button variant="outlined" color="primary" onClick={() => navigate('/')}>
                    {t('btn')}
                  </Button>
                </Box>
              </>
            )}
          </Paper>
        </Container>
      )}
    </Box>
  );
};

export default PaymentSuccessPage;
